import { Badge } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { getEventTypeMeta } from '../../constants/eventTypes.js';
import { SEVERITY_RISK } from '../../constants/severities.js';

/**
 * Read-only recap of the event being handed over (title, id, type and risk), so
 * the collaborator picker below has context without leaving the modal.
 */
function EscalateEventSummary({ event }) {
  const { t } = useTranslation('work-queues-app');
  if (!event) return null;

  const typeMeta = getEventTypeMeta(event.type);
  const risk = SEVERITY_RISK[event.severity];

  return (
    <div className="rounded-lg border border-edge bg-surface-muted px-4 py-3">
      <div className="flex items-start justify-between gap-3">
        <p className="text-sm font-medium text-content">{event.title}</p>
        <span className="shrink-0 text-xs text-content-faint">{event.id}</span>
      </div>
      <div className="mt-2 flex items-center justify-between gap-3">
        <div>
          {typeMeta && (
            <Badge variant="alert" size="medium" className="!border-transparent">
              {t(typeMeta.labelKey)}
            </Badge>
          )}
        </div>
        {risk && (
          <span className={`text-xs font-medium ${risk.className}`}>{t(risk.labelKey)}</span>
        )}
      </div>
    </div>
  );
}

export default EscalateEventSummary;
